<template>
  <section>
    <!-- change filter event ki ga $emitamo v coachfilter (updatedFilters) -->
    <!-- setFilters je event ki ga nato tukaj v methods definiramo -->
    <coach-filter @change-filter="setFilters"></coach-filter>
  </section>

  <section>
    <base-card>
      <div class="controls">
        <!-- "mode" je props ki smo ga definirali za styles -->
        <base-button mode="outline">Refresh</base-button>
        <!-- "link" in "to" sta propsa definirana v BaseButton -->
        <base-button v-if="!isCoach" link to="/register">Register as a Coach</base-button>
      </div>
      <ul v-if="hasCoaches">
        <!-- podatki ki jih pošiljaš v coachItem -->
        <coach-item
          v-for="coach in filteredCoaches"
          :key="coach.id"
          :id="coach.id"
          :firstName="coach.firstName"
          :lastName="coach.lastName"
          :rate="coach.hourlyRate"
          :areas="coach.areas"
        ></coach-item>
      </ul>
      <h3 v-else>No Coaches Found</h3>
    </base-card>
  </section>
</template>

<script>
import CoachItem from '@/components/coaches/CoachItem.vue';
import CoachFilter from '@/components/coaches/CoachFilter.vue';

export default {
  components: {
    CoachItem,
    CoachFilter,
  },
  data() {
    return {
      // isti filtri kot v coachesFilter ki so overriddani z novo setFilters metodo
      activeFilters: {
        frontend: true,
        backend: true,
        career: true,
      },
    };
  },
  // Preko computed Reachaš getterja v Coaches, kateri poda list s Coaches
  computed: {
    filteredCoaches() {
      // coaches ki smo ga definali v filter in jih pošiljamo prek $emit
      const coaches = this.$store.getters['coaches/coaches'];
      // nato filtriramo coaches array preko .filter  funkcije
      return coaches.filter((coach) => {
        // če je this.activeFilters.frontend TRUE potem coach ki ima areas.frontend bo prikazan
        // includes() je native funkcija ki vrne true če je ta value v arrayu
        if (this.activeFilters.frontend && coach.areas.includes('frontend')) {
          //s true ga obdržimo prikazanega
          return true;
        }
        if (this.activeFilters.backend && coach.areas.includes('backend')) {
          return true;
        }
        if (this.activeFilters.career && coach.areas.includes('career')) {
          return true;
        }

        // nazadnje returnamo false, da coache ki nimajo tega area odstranimo
        return false;
      });
    },
    // Boolean
    hasCoaches() {
      return this.$store.getters['coaches/hasCoaches'];
    },
    // isCoach() je funkcija ki se nanaša na funkcijo v coach getters.js
    isCoach() {
      return this.$store.getters['coaches/isCoach'];
    },
  },
  methods: {
    // updatedFilters iz coachFilter $emit enačimo z filters v data()
    setFilters(updatedFilters) {
      this.activeFilters = updatedFilters;
    },
  },
};
</script>
<style scoped>
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.controls {
  display: flex;
  justify-content: space-between;
}
</style>
